import './overview.html';
import { accounts, accountsDetails, intradays } from '../../../../services/arsweb/RoutingPaths';
import { DetailViewController } from '../../../../controller/DetailViewController';
import { CONSOLIDATION_CURRENCY_PARAMS } from '../../../../controller/CommonViewController';
import { DEF_CURRENCY, CONSOLIDATION_CURRENCY } from '../../../dashboard/dashboard';
import { REACT_AH_CRUMBS_DETAIL_DATA_READY } from "../../../../components/react/AwApplicationHeaderHelpers/AwApplicationHeaderHelpers";
export const DETAIL_INTRADAYROUTE = 'app.intradayDetail';

export class IntradayDetailController extends DetailViewController {

    constructor($scope, userService, arsMainDependencies) {
        super($scope, userService, arsMainDependencies);
        this.userService = userService;
        this.filterFormatter = userService.filterFormatter;
        this.initDateRange();
    }

    initSessionPersistanceDependencies($stateParams) {
        this.$scope.consolitationcurrency = this.sessionPersistance.get(CONSOLIDATION_CURRENCY) || DEF_CURRENCY;
        this.sessionPersistance.set(CONSOLIDATION_CURRENCY, this.$scope.consolitationcurrency);
        if($stateParams.id && $stateParams.parentID) {
            this.$scope.accountID = $stateParams.parentID;
            this.intradayID = $stateParams.id;
            this.$scope.detailPromise = this.loadIntraday();
        }
    }

    loadIntraday() {
        this.accountService.service.config.params[CONSOLIDATION_CURRENCY_PARAMS] = this.$scope.consolitationcurrency.code;
        return this.accountService.getUserData(accounts + intradays + "/" + this.intradayID).then((data) => {
            this.$scope.intradayInfo = data;
            this.$scope.accountInfo = data.account;
            this.fractionDigits = this.$scope.accountInfo.balance.fractionDigits;

            this.$scope.$emit(REACT_AH_CRUMBS_DETAIL_DATA_READY, this.$scope.accountInfo);

            this.userService.promise.then(() => {
                this.f13DateTime = this.filterFormatter('fsDateTime')(this.$scope.intradayInfo.f13DateTime);
                this.debitSum = this.filterFormatter('fsNumber')(this.$scope.intradayInfo.debitSum,
                    this.$scope.accountInfo.balance.fractionDigits);
                this.creditSum = this.filterFormatter('fsNumber')(this.$scope.intradayInfo.creditSum,
                    this.$scope.accountInfo.balance.fractionDigits);
            });
        });
    }

    loadAccount (pickedDate) {
        this.accountService.service.config.params[CONSOLIDATION_CURRENCY_PARAMS] = this.sessionPersistance.get(CONSOLIDATION_CURRENCY).code;
        this.$scope.consolitationcurrency =  this.sessionPersistance.get(CONSOLIDATION_CURRENCY);
        this.accountService.service.config.params['id'] = this.$scope.accountID;
        this.accountService.service.config.params['endDate'] = pickedDate.valueOf();
        return this.accountService.getUserData(accountsDetails).then(data => {
            this.$scope.accountInfo = data;
            this.$scope.intradayInfo.account = data;
        });
    }
}
